import React from 'react';
import { Modal, Spin, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const { Text } = Typography;

const LoadingPopup = ({ isVisible, message }) => {
    const antIcon = (
        <LoadingOutlined
            style={{ fontSize: 42, color: 'var(--color-teal-mid)' }}
            spin
        />
    );

    return (
        <Modal
            open={isVisible}
            footer={null}
            closable={false}
            centered
            width={300}
            styles={{ mask: { backdropFilter: 'blur(4px)' } }}
        >
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
                <Spin indicator={antIcon} />
                <div style={{ marginTop: 20 }}>
                    <Text style={{ fontSize: '17px', fontWeight: 500 }}>
                        {message}
                    </Text>
                </div>
            </div>
        </Modal>
    );
};

export default LoadingPopup;